<template>
  <v-dialog persistent :value="true" scrollable max-width="500">
  <!-- <v-layout row justify-center align-center wrap> -->
    <v-card>
      <v-card-title
        primary-title
        style="font-weight: bold; font-size: 1.5em;"
      >
        Confirme seu cadastro
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text justify-center>
        <v-flex xs12><span>Olá {{this.$auth.user().id_text.split(' ')[0]}}! Enviamos um código de confirmação para o e-mail</span></v-flex>
        <!-- <v-flex xs12><span>Ola "{{this.$auth.user().id_text.split(' ')[0]}}"! Estamos quase la Enviamos um código de confirmação para o e-mail</span></v-flex> -->
        <!-- <v-flex xs12><span>Conclua seu registro digitando o código enviado para o e-mail</span></v-flex> -->
        <!-- <v-flex xs12><span>Para concluir o seu registro digite o código enviado no e-mail</span></v-flex> -->
        <v-flex xs12><span><strong>"{{this.$auth.user().email}}"</strong></span></v-flex>
        <v-flex xs12>
          <v-text-field prepend-icon="check" key="8" :error-messages="errors.collect('code')" name="codigo" label="Digite o código"
                        v-model="codigo"
          ></v-text-field>
        </v-flex>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-flex xs12 class="text-xs-center">
            <v-btn dark class="gradient" @click="confirm()" :loading="loading">Confirmar</v-btn>
            <v-btn dark class="gradient" @click="sendCode()" :loading="loading">Reenviar Código</v-btn>
            <v-btn flat @click="$emit('close')" :loading="loading">Mais Tarde</v-btn>
          </v-flex>
      </v-card-actions>
      <v-card-actions>
          <v-flex xs12>
            Em caso de dúvidas
            <a
              @click="location.reload(true)"
            >
              clique aqui
            </a>
            , e entre em contato conosco.
          </v-flex>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  // import { Validator } from 'vee-validate'
  /* eslint-disable eqeqeq */
  export default {
    name: 'PConfirmaRegister',
    data: () => ({
      loading: false,
      codigo: ''
    }),
    methods: {
      confirm () {
        if (this.codigo != this.$auth.user().code) {
          this.$store.commit('snackbar/change_values', {
            text: 'Favor colocar o código correto!',
            color: 'warning',
            dialog: true
          })
          this.errors.add({
            field: 'code',
            msg: 'Código incorreto'
          })
          return 0
        }
        this.loading = true
        this.$http.post(`auth/confirm_code`).then((res) => {
          this.$auth.user().code = null
          this.$store.commit('snackbar/change_values', {
            text: 'Registro confirmado com sucesso!',
            color: 'success',
            dialog: true,
            timeout: 6000
          })
          this.loading = false
          this.$emit('close')
        },
        (err) => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível confirmar o código, porfavor contate o suporte',
            color: 'error',
            dialog: true
          })
          this.loading = false
        }
        )
      },
      sendCode () {
        this.loading = true
        this.$http.post(`auth/register_code`, {'user': this.$auth.user().id_text, 'email': this.$auth.user().email, 'code': this.$auth.user().code, 'sendEmail': true}).then((res) => {
          console.log(res)
          this.$store.commit('snackbar/change_values', {
            text: 'O código foi reenviado, porfavor confira também a lixeira e a caixa de spam',
            color: 'success',
            dialog: true,
            timeout: 6000
          })
          this.errors.clear()
          this.loading = false
        },
        (err) => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível enviar o código, porfavor contate o suporte',
            color: 'error',
            dialog: true
          })
          this.loading = false
        })
      },
      openSuport () {
        document.getElementById('purechat-btn').click()
      }
    },
    watch: {
      codigo (val) {
        if (val.length === 0) {
          this.errors.clear()
        }
      }
    }
  }
</script>

<style scoped>
  .gradient {
    background: linear-gradient(40deg, #4a97ce, #5fbf8d);
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PConfirmRegister.vue